/**============================================================
*   [Class] 数字のカウントアップ
============================================================*/
export default class CountUpNum {
  constructor(
    target,
    key,
  )
  {
    this.target = target;
    this.key = key;

    // カウンター要素をすべて取得
    this.items = this.target.querySelectorAll( '.js-count-up__item' );

    const getDecimalPointLength =( n ) => {
      return ( String( n ).split( '.' )[1] || '' ).length;
    }

    // コールバック関数(カウントアップ処理)
    this.observeAction = ( entries ) => {
      entries.forEach( entry => {
        // 可視領域に到達したとき
        if ( entry.isIntersecting ) {
          // .is-visible セレクタがない場合のみ
          if ( ! entry.target.classList.contains( 'is-visible' ) ) {

            // カウントアップ処理
            const counterEle = entry.target.querySelector( '.counter .number' );
            // カウント開始時の値(初期値: 0)
            const from = parseFloat( entry.target.dataset.from || 0 );
            // カウント終了時の値(初期値: 0)
            const to = parseFloat( entry.target.dataset.to || 0 );
            // アニメーション時間(ミリ秒／初期値: 1500)
            const duration = parseInt( entry.target.dataset.duration ) || 1500;

            if ( !Number.isFinite( from ) || !Number.isFinite( to ) || from > to ) {
              return false;
            }

            const increment = to - from;
            const decimalPointLength = getDecimalPointLength( increment );
            const startTime = performance.now();

            const countUp = ( ) => {
              const elapsed = performance.now() - startTime;
              const countValue = ( from + ( ( elapsed / duration ) * increment ) ).toFixed( decimalPointLength );

              if ( countValue >= to ) {
                counterEle.innerText = to.toLocaleString();
              } else {
                counterEle.innerText = parseFloat( countValue ).toLocaleString();
                requestAnimationFrame( countUp );
              }
            }

            requestAnimationFrame( countUp );

            // .is-visible セレクタを追加
            entry.target.classList.add( 'is-visible' );
          }
        }
      })
    }

    // 交差判定条件
    this.options = {
      threshold: 1,  // カウンター要素がすべて画面に表示されたとき(= 1)
    }

    // 交差オブザーバーのインスタンスを生成
    this.observer = new IntersectionObserver( this.observeAction, this.options );

    // すべてのカウンター要素について
    this.items.forEach( target => {
      // 監視を開始
      this.observer.observe( target );
    });
  }
}
